const siteSiteLaunchTheme = {
    siteLaunch: {
        bgStart: 'transparent',
        bgEnd: 'transparent',
    },
};

export default siteSiteLaunchTheme;
